import { useEditor } from '@craftjs/core';
import { TabContext, TabPanel } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import segmentTools from '../../../constants/segmentTools';
import useSegmentBuilder from '../../../hooks/useSegmentBuilder';
import { getSelectedMenu, getSelectedSegment } from '../../../redux/selectors/segmentBuilderSelectors';
import { ASSETS } from '../../../utils/config';
import Input from '../../Input';
import TextView from '../../TextView';
import { Settings as ToolSettings } from './Settings';
import ToolbarBody from './ToolbarBody';
import * as Styled from './styles';
import { handleMenuChange } from '../../../redux/reducers/segmentBuilder';

const RenderCodeBlock = React.memo(({ searchTerm, handleSearchChange, filteredTools }) => {
  return (
    <>
      <Styled.Header>
        <img src={ASSETS.segmentEditor.Edit} style={{ marginRight: 5 }} />
        <TextView variant="title" style={{ height: '100%' }}>
          Build Menu
        </TextView>
      </Styled.Header>
      <Input
        variant="secondary"
        placeholder="Search Block"
        search={true}
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <ToolbarBody data={filteredTools} />
    </>
  );
});

const Toolbar = ({ isVisible = false }) => {
  const { isToolSelected } = useSegmentBuilder();
  const { selected, isEnabled } = isToolSelected() || {};
  const [selectedTab, setSelectedTab] = useState('0');
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [filteredTools, setFilteredTools] = useState(segmentTools); // Filtered tools
  const selectedArc = useSelector(getSelectedSegment);
  const { query } = useEditor();

  useEffect(() => {
    if (!selected) {
      setSelectedTab('0');
    }
  }, [selected]);


  const dispatch  = useDispatch();
  useEffect(() => {
    const items = query.getNodes();

    const addClickListeners = () => {
      Object.values(items).forEach((node) => {
        const { dom } = node || {};
        dom?.addEventListener('click', handleClick);
      });
    };

    const removeClickListeners = () => {
      Object.values(items).forEach((node) => {
        const { dom } = node || {};
        dom?.removeEventListener('click', handleClick);
      });
    };

    addClickListeners();
    return () => {
      removeClickListeners();
    };
  }, [query, isEnabled, selected]);

  
  const handleClick = () => {
    // setSelectedTab('1');
    if (isEnabled && selected && selected?.name !== 'AccordionContainer') {
      setSelectedTab('1');
    } else {
      setSelectedTab('0');
    }
  };

  useEffect(() => {
    setSelectedTab('0');
  }, [selectedArc?.id]);

  const segmentSettingsEnabled = useSelector(
    (state) => state.segmentSettings.segmentSettingsEnabled
  );
  useEffect(() => {
    if (segmentSettingsEnabled) {
      setSelectedTab('1');
    }
  }, [segmentSettingsEnabled]);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = segmentTools.map((category) => {
      const filteredElements = category.elements.filter((tool) =>
        tool.title.toLowerCase().includes(value)
      );
      return { ...category, elements: filteredElements };
    });

    setFilteredTools(filtered.filter((category) => category.elements.length > 0));
  };

  return (
    <Styled.Pane isVisible={selectedArc}>
      <Styled.mainStack isVisible={isVisible}>
        <TabContext value={selectedTab}>
          <TabPanel value="0">
            {
              <RenderCodeBlock
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                filteredTools={filteredTools}
              />
            }
          </TabPanel>

          <TabPanel value="1">
            {isEnabled && selected ? (
              <ToolSettings setSelectedTab={setSelectedTab} />
            ) : (
              <RenderCodeBlock
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                filteredTools={filteredTools}
              />
            )}
          </TabPanel>
        </TabContext>
      </Styled.mainStack>
    </Styled.Pane>
  );
};

export default Toolbar;
